import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Infinity symbol (∞) — lemniscate. Two cubic Bézier loops sharing
 *  the centre crossing, so the curves *cross* at (8, 8) rather than
 *  forming two tangent ovals. Hand-tuned control points keep the
 *  loops symmetric and readable at 14px. */
export function IcnInfinity(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="infinity">
      <path d="M3 8 C3 5 7 5 8 8 C9 11 13 11 13 8 C13 5 9 5 8 8 C7 11 3 11 3 8 Z" />
    </Svg>
  );
}
